import { Capacitor } from '@capacitor/core'
import { registerSW } from 'virtual:pwa-register'

export let updateServiceWorker: ((reloadPage?: boolean) => Promise<void>) | null = null

if (!Capacitor.isNativePlatform()) {
  updateServiceWorker = registerSW({
    immediate: true,
    onNeedRefresh() {
      console.info('[PWA] New content available. It will be applied on next app load.')
    },
    onOfflineReady() {
      console.info('[PWA] App is ready for offline usage.')
    },
    onRegisterError(error) {
      console.error('[PWA] Service worker registration failed:', error)
    },
  })
}
